import { ILayerDefinition } from '@esri/arcgis-rest-feature-service';
import { FieldType } from '@esri/arcgis-rest-request';
import {
  CalciteAccordion,
  CalciteAccordionItem,
  CalciteAction,
  CalciteIcon,
} from '@esri/calcite-components-react';
import { esriTypeLookup } from '../../consts/esriTypeInfo';
import { FieldEditor } from './FieldEditor';

type FieldManagerProps = {
  layerDef: ILayerDefinition;
  layerUrl: string;
  isAdminMode: boolean;
  onVisibilityChange: (fieldName: string, isVisible: boolean) => void;
  hiddenFields: string[];
};

const getTypeIcon = (type: FieldType) => {
  if (type in esriTypeLookup) {
    return esriTypeLookup[type].icon;
  }
  console.error('Unknown type:', type);
  return 'unknown';
};

export function FieldManager({
  layerDef,
  layerUrl,
  isAdminMode,
  onVisibilityChange,
  hiddenFields,
}: FieldManagerProps) {
  const fields = layerDef.fields ?? [];

  return (
    <CalciteAccordion>
      {fields.map((field) => {
        const isVisible = !hiddenFields.includes(field.name);

        return (
          <CalciteAccordionItem
            key={field.name}
            heading={field.name}
            description={`Alias: ${field.alias}`}
            iconStart={getTypeIcon(field.type)}
          >
            <CalciteIcon scale="s" slot="icon" icon={getTypeIcon(field.type)} />
            <CalciteAction
              slot="actions-end"
              icon={isVisible ? 'view-visible' : 'view-hide'}
              text="Visibility"
              onClick={() => onVisibilityChange(field.name, !isVisible)}
            />
            <FieldEditor
              mode={isAdminMode ? 'edit' : 'view'}
              field={field}
              layerUrl={layerUrl}
            />
          </CalciteAccordionItem>
        );
      })}
    </CalciteAccordion>
  );
}
